<div class="m-auto ">
  <div class="flex items-end justify-between flex-wrap md:flex-nowrap  m-auto max-w-[62rem]">
    <div class="mx-2 mb-3 md:mb-0">
      <h1 class="mb-2" style="font-weight: 600; font-size: 16px; line-height: 100%; letter-spacing: 0%;">{{ 'translate_subscription' | translate }}</h1>
      <p class="text-gray-400" style="font-weight: 400; font-size: 14px; line-height: 100%; letter-spacing: 0%;">{{ 'translate_subscription_subtitle' | translate }}</p>
    </div>
    <div class="rounded-lg p-1 mx-2 mt-[8px]" style="border: solid 1px #694ED6;">
      @for (link of subLinks; track $index) {
      <div [routerLink]="link.path" class="py-2 px-7 rounded inline-block cursor-pointer text-gray-500"
        routerLinkActive="bg-[#694ED6] text-white">{{ link.name | translate }}</div>
      }
    </div>
  </div>
  <div class="mt-[1rem] md:mt-[2.5rem]">
    <router-outlet></router-outlet>
  </div>
</div>
